import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../../../../../../utils/auth';
import { useGetDashboardSection } from '../../../../../../../queries/queryDashboardSection';
import { DASHBOARD_CONTEXTS, DASHBOARD_SECTION_KEYS } from './dashboardContexts';
import { DynamicSection } from './DynamicSection';
import { LoadingCircularProgress } from '../../../../../../../components/atoms/LoadingCircularProgress';

const DEFAULT_SECTION_KEYS = Object.values(DASHBOARD_SECTION_KEYS);

const useSectionsLoadingState = ({ clientId, context, sectionKeys }) => {
  const r0 = useGetDashboardSection({ clientId, context, sectionKey: sectionKeys[0] });
  const r1 = useGetDashboardSection({ clientId, context, sectionKey: sectionKeys[1] });
  const r2 = useGetDashboardSection({ clientId, context, sectionKey: sectionKeys[2] });
  const r3 = useGetDashboardSection({ clientId, context, sectionKey: sectionKeys[3] });
  const results = [r0, r1, r2, r3].slice(0, sectionKeys.length);
  return {
    allLoading: results.every(r => r.isLoading),
    results: results.map((r, i) => ({ sectionKey: sectionKeys[i], ...r }))
  };
};

export const DynamicDashboardComponent = ({
  currentUser,
  context = DASHBOARD_CONTEXTS.BIONEGOCIOS,
  sectionKeys = DEFAULT_SECTION_KEYS
}) => {
  const clientId = currentUser && currentUser.client_id;
  const { allLoading, results } = useSectionsLoadingState({ clientId: clientId || 0, context, sectionKeys });

  if (!clientId || !context || !Array.isArray(sectionKeys) || sectionKeys.length === 0) {
    return null;
  }

  if (allLoading)
    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
        <LoadingCircularProgress style={{ margin: 0 }} />
      </div>
    );

  return (
    <>
      {results.map(({ sectionKey, data, isError }) => {
        if (isError || !data || !data.section || !Array.isArray(data.blocks)) return null;
        return <DynamicSection key={sectionKey} section={data.section} blocks={data.blocks} />;
      })}
    </>
  );
};

DynamicDashboardComponent.propTypes = {
  currentUser: PropTypes.shape({
    client_id: PropTypes.number
  }),
  context: PropTypes.string,
  sectionKeys: PropTypes.arrayOf(PropTypes.string)
};

const mapStateToProps = state => ({ currentUser: getCurrentUser(state) });

export const DynamicDashboard = connect(mapStateToProps)(DynamicDashboardComponent);
